var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flixIcon',{staticClass:"icon",attrs:{"id":'check'}}),_c('b-flix-h1',[_vm._v(_vm._s(_vm.validation)+"%")]),_c('b-flix-p',[_vm._v(_vm._s(_vm.$t('message.validation')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }